var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row scrolling-wrapper",
          attrs: { id: "carousel-vehicle" }
        },
        [
          _c("content-card", { attrs: { fieldData: _vm.fieldData[7] } }),
          _vm._v(" "),
          _c("content-card", { attrs: { fieldData: _vm.fieldData[8] } }),
          _vm._v(" "),
          _c("content-card", { attrs: { fieldData: _vm.fieldData[9] } }),
          _vm._v(" "),
          _c("content-card", { attrs: { fieldData: _vm.fieldData[10] } }),
          _vm._v(" "),
          _c("content-card", { attrs: { fieldData: _vm.fieldData[11] } })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("p", [_vm._v("This is the library of available form elements.")]),
          _vm._v(" "),
          _c("form", [
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v("Input Text (" + _vm._s(_vm.fieldData[0].field_name) + ")")
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[0] }
                      }),
                      _vm._v(" "),
                      _c("input-text", {
                        attrs: { fieldData: _vm.fieldData[0] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[0] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[0] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Radios (" + _vm._s(_vm.fieldData[1].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[1] }
                      }),
                      _vm._v(" "),
                      _c("input-radioalt", {
                        attrs: { fieldData: _vm.fieldData[1] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[1] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Checkboxes (" + _vm._s(_vm.fieldData[2].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-check" },
                    [
                      _c("input-checkbox", {
                        attrs: { fieldData: _vm.fieldData[2] }
                      }),
                      _vm._v(" "),
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[2] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[2] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Multi Checkboxes (" +
                  _vm._s(_vm.fieldData[3].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[3] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[3] }
                      }),
                      _vm._v(" "),
                      _c("input-multicheckbox", {
                        attrs: { fieldData: _vm.fieldData[3] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Selects (" + _vm._s(_vm.fieldData[4].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[4] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[4] }
                      }),
                      _vm._v(" "),
                      _c("input-select", {
                        attrs: { fieldData: _vm.fieldData[4] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Text: Email (exotic) (" +
                  _vm._s(_vm.fieldData[5].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[5] }
                      }),
                      _vm._v(" "),
                      _c("input-text", {
                        attrs: { fieldData: _vm.fieldData[5] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[5] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[5] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input List (" + _vm._s(_vm.fieldData[12].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[12] }
                      }),
                      _vm._v(" "),
                      _c("input-list", {
                        attrs: { fieldData: _vm.fieldData[12] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[12] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[12] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Date (Long) (" +
                  _vm._s(_vm.fieldData[13].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[13] }
                      }),
                      _vm._v(" "),
                      _c("input-datelong", {
                        attrs: { fieldData: _vm.fieldData[13] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[13] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[13] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Date (Short) (" +
                  _vm._s(_vm.fieldData[14].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "field-container" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[14] }
                      }),
                      _vm._v(" "),
                      _c("input-dateshort", {
                        attrs: { fieldData: _vm.fieldData[14] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[14] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[14] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Date (MMYYYY) (" +
                  _vm._s(_vm.fieldData[15].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "field-container" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[15] }
                      }),
                      _vm._v(" "),
                      _c("input-datemmyyyy", {
                        attrs: { fieldData: _vm.fieldData[15] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[15] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[15] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Address (" + _vm._s(_vm.fieldData[16].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "field-container" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("input-address", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Credit Card (" +
                  _vm._s(_vm.fieldData[16].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "field-container" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("input-creditcard", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("field-subtext", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[16] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Radios with Images (" +
                  _vm._s(_vm.fieldData[17].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[17] }
                      }),
                      _vm._v(" "),
                      _c("input-radio-images", {
                        attrs: { fieldData: _vm.fieldData[17] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[17] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Selects with Images (" +
                  _vm._s(_vm.fieldData[18].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[18] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[18] }
                      }),
                      _vm._v(" "),
                      _c("input-select-images", {
                        attrs: { fieldData: _vm.fieldData[18] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Input Radios (" + _vm._s(_vm.fieldData[19].field_name) + ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[19] }
                      }),
                      _vm._v(" "),
                      _c("input-radio-icons", {
                        attrs: { fieldData: _vm.fieldData[19] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[19] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Locate Property button (" +
                  _vm._s(_vm.fieldData[20].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[20] }
                      }),
                      _vm._v(" "),
                      _c("google-locate-button", {
                        attrs: { pageData: _vm.fieldData[20] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[20] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "Product Input Selects (" +
                  _vm._s(_vm.fieldData[21].field_name) +
                  ")"
              )
            ]),
            _vm._v(" "),
            true
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("field-info", {
                        attrs: { fieldData: _vm.fieldData[21] }
                      }),
                      _vm._v(" "),
                      _c("field-messages", {
                        attrs: { fieldData: _vm.fieldData[21] }
                      }),
                      _vm._v(" "),
                      _c("input-product-select", {
                        attrs: { fieldData: _vm.fieldData[21] }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("button", { attrs: { type: "submit" } }, [_vm._v("Submit")])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "offset-md-1 col-md-5" },
          [
            _c("p", [
              _vm._v("Active element: "),
              _c("pre", { staticStyle: { "font-family": "'Courier'" } }, [
                _vm._v(_vm._s(_vm.activeElement))
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.fieldData, function(item, i) {
              return _c("div", { key: i }, [
                _c(
                  "table",
                  {
                    staticClass: "table table-dark",
                    staticStyle: { "font-size": "12px" }
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            "margin-top": "3em",
                            "border-top": "5px solid #ccc"
                          }
                        },
                        [
                          _c("th", [_vm._v("field_name")]),
                          _c("td", [_vm._v(_vm._s(item.field_name))])
                        ]
                      ),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("field_value")]),
                        _c("td", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v(_vm._s(item.field_value))]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("val_rules")]),
                        _c("td", [_vm._v(_vm._s(item.rules))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("field_type")]),
                        _c("td", [_vm._v(_vm._s(item.field_type))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("label")]),
                        _c("td", [_vm._v(_vm._s(item.label))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("help_text")]),
                        _c("td", [_vm._v(_vm._s(item.help_text))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("values")]),
                        _c("td", [_vm._v(_vm._s(item.values))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("is_required")]),
                        _c("td", [_vm._v(_vm._s(item.is_required))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("placeholder")]),
                        _c("td", [_vm._v(_vm._s(item.placeholder))])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("th", [_vm._v("sub_text")]),
                        _c("td", [_vm._v(_vm._s(item.sub_text))])
                      ])
                    ])
                  ]
                )
              ])
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("p", [_vm._v("Navigation items")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "row scrolling-wrapper",
        staticStyle: {
          position: "fixed",
          width: "100%",
          "z-index": "10",
          "margin-top": "-1em"
        },
        attrs: { id: "carousel-vehicle-top-scrollbar" }
      },
      [
        _c("div", { staticClass: "card col-md-3" }),
        _vm._v(" "),
        _c("div", { staticClass: "card col-md-3" }),
        _vm._v(" "),
        _c("div", { staticClass: "card col-md-3" }),
        _vm._v(" "),
        _c("div", { staticClass: "card col-md-3" }),
        _vm._v(" "),
        _c("div", { staticClass: "card col-md-3" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "breadcrumb" }, [
      _c("li", { staticClass: "breadcrumb-item" }, [
        _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "breadcrumb-item active" }, [_vm._v("Settings")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a2ff67a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2ff67a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/Settings.vue
// module id = null
// module chunks = 